import React from 'react';
import {useNavigate} from 'react-router-dom';
import { useEffect, useState } from 'react';

import axios from 'axios';
 

function Searchbox(props) {

    const [searchValue, setSearchValue] = useState();
    const [searchDate, setSearchDate] = useState();
    const [items, setItems] = useState([]);
    const [relatedSearches, setRelatedSearches] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    // const searchCollectionRef = collection(db, "Searcholl");

    // const [searchTerms, setSearchTerms] = useState([]);

    const fetchRelatedSearches = async () => {
        try {
            setLoading(true);
            const response = await axios.get('https://server.taskticks.com/api/items/keywords/random');
            const keywords = response.data.map(item => item.keyword);
            setRelatedSearches(keywords);
            setError(null);
        } catch (err) {
            console.error('Error fetching related searches:', err);
            setError('Failed to load related searches');
            // Fallback to default searches if API fails
            setRelatedSearches([
                "Compliance Services",
                "Accountancy Services", 
                "Cpa Services",
                "Compliance Audit",
                "Business Services"
            ]);
        } finally {
            setLoading(false);
        }
    };

    const handleRelatedSearchClick = (searchTerm) => {
        // Encode the search term for URL
        postSearch(searchTerm, new Date());
        const encodedSearchTerm = encodeURIComponent(searchTerm);
        // Create the search URL with the keyword
        const searchUrl = `http://af.xdock.co/?pid=21000&subid=210002&keyword=${encodedSearchTerm}`;
        // Open in new tab
        window.open(searchUrl, '_blank', 'noopener,noreferrer');
    };

    const postSearch = async(value, date) => {
      //  console.log(value, date);

      //  await addDoc(searchCollectionRef, {
      //   terms:  value,
      //   Date: date
      //  });
       try{
        const response = await axios.post('https://server.taskticks.com/api/items/lukkol', {
        terms:  value,
        Date: date
        });
        setItems([...items, response.data]);
      } catch (error) {
        console.error(error);
      }


    }



     const navigate = useNavigate();
     
     useEffect(() => {
        fetchRelatedSearches();
     }, []);

    //  useEffect(()=> {
    //   const queryString = window.location.search;
    //   const urlParams = new URLSearchParams(queryString);
    //   const qValue = urlParams.get('q');
    //   setSearchValue(qValue);
    //   // console.log(qValue);
    //   if(qValue) {
    //     search();
    //   }
    // }, [])
    // const enteredSearch = (e) => {
    //   setSearchValue(e.target.value);
    //   // console.log(e.target.value);
    // }
    // const search = (event) => {
    //     //  console.log(event);
    //    if(event) {
    //      if(event.key === 'Enter') {
    //        // console.log("enter works");
    //        let searchYahoo = document.getElementById('searchYahoo');
    //        // console.log(searchYahoo.value);
    //         let SYvalue = searchYahoo.value.trim();
    //         if(SYvalue.length === 0){
    //           return false;
    //         }
           
    //         let SearchedDate = new Date();
    //         // setSearchDate(Date);
    //         postSearch(SYvalue, SearchedDate);
    //         // return false;
    //         // https://fwd.searchnet.info/f?cid=15172&q=kw
    //        // navigate('/search?q='+ SYvalue);
    //         // console.log(queryString);
    //         const url = `/search?q=${SYvalue}`;
    //          window.history.pushState(null, null, url);
    //          let passLink = 'http://af.xdock.co/?pid=21000&subid=210002&keyword='+ SYvalue;
    //             // let passLink = 'https://www.google.com/search?q='+ SYvalue + '&safe=active';
    //         //  console.log(passLink); 
    //         //  return false;
    //         setTimeout(() => {
    //          //  navigate(passLink, { replace: true });
    //           window.open(passLink, '_target', 'noreferrer');
    //         }, 500)
            
            
    //       }
    //     }else {
    //      // let searchYahoo = document.getElementById('searchYahoo');
    //      // // console.log(searchYahoo.value);
    //      //  let SYvalue = searchYahoo.value;
    //      const queryString = window.location.search;
    //      const urlParams = new URLSearchParams(queryString);
    //      const qValue = urlParams.get('q');
    //      let SearchedDate = new Date();
    //      // setSearchDate(Date);
    //      postSearch(qValue, SearchedDate);
    //        navigate('/search?q='+ qValue);
    //       // console.log(queryString);
    //       const url = `/search?q=${qValue}`;
    //        window.history.pushState(null, null, url);
    //       //  let passLink = 'https://www.google.com/search?q='+ qValue + '&safe=active';
    //        let passLink = 'http://af.xdock.co/?pid=21000&subid=210002&keyword='+ qValue;
    //     //  console.log(passLink);
    //     //  return false;
    //       setTimeout(() => {
    //        //  navigate(passLink, { replace: true });
    //         window.open(passLink, '_self', 'noreferrer');
    //       }, 500)
    //    }
        
       
    //    }
    
    return (
        <div className="related-searches-container">
            <h1 className="related-searches-heading">Related searches</h1>
            {loading ? (
                <div className="loading-container">
                    <div className="spinner"></div>
                    {/* <div className="loading-text">Loading related searches...</div> */}
                </div>
            ) : error ? (
                <div className="error-message">{error}</div>
            ) : (
                <div className="related-searches-list">
                    {relatedSearches.map((search, index) => (
                        <a 
                            href={`http://af.xdock.co/?pid=21000&subid=210002&keyword=${encodeURIComponent(search)}`}
                            target="_blank"
                            key={index} 
                            className="related-search-button"
                            // onClick={() => handleRelatedSearchClick(search)}
                        >
                            <span className="button-text">{search}</span>
                            <img src="/right arrow.svg" alt="arrow" className="arrow-icon" />
                        </a>
                    ))}
                </div>
            )}
        </div>
    );
}

export default Searchbox;